import { useTranslation } from 'react-i18next';
import React from 'react';
import cx from 'clsx';

import { useDeviceTypeIsMobile, useTheme } from '@/hooks';
import { FeedArticle } from '@/views/Stream';

import { BotAlertContent } from '../../BotEvent';
import { DowngradeCard } from '../DowngradeCard';
import style from './index.module.scss';

type BotAlertCardProps = {
  article: FeedArticle;
  isDetails?: boolean;
};

const SUPPORT_KIND = ['profile_tx'];

export const BotAlertCard = ({ article }: BotAlertCardProps) => {
  const { t } = useTranslation();

  const isMobile = useDeviceTypeIsMobile();
  const { isDark } = useTheme();

  return article.monitor_alert?.event?.kind &&
    SUPPORT_KIND.includes(article.monitor_alert?.event?.kind) ? (
    <div className={cx(style.botAlertCard, isDark && style.isDark, isMobile && style.mobile)}>
      <div className={style.title}>
        <div className={style.creator}>{t('BotAlertCard.x0hi0z')}</div>
      </div>
      <div className={style.body}>
        <BotAlertContent data={article.monitor_alert} hidePrice={isMobile} />
      </div>
    </div>
  ) : (
    <DowngradeCard />
  );
};
